import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import EventCard from 'app/features/events/components/EventDashboardSimple/EventCard';

export default class EventsRow extends React.Component {
  static propTypes = {
    selectedId: PropTypes.string,
    time: PropTypes.string,
    events: PropTypes.array,
    handleEventClick: PropTypes.func,
  };

  static defaultProps = {
    selectedId: undefined,
    time: undefined,
    handleEventClick: undefined,
    events: [],
  };

  renderPaymentCards = () => _.map(this.props.events, (event) => (
    <EventCard
      {...event}
      selected={event?.id === this.props.selectedId}
      event={event}
      handleEventClick={this.props.handleEventClick}
      key={event.id}
    />
  ));

  render(): React.ReactNode {
    return (
      <div className="row">
        <div className="event-parent-row">
          <div className="event-row-label">
            <span>{this.props.time}</span>
          </div>
          <div className="event-row">{this.renderPaymentCards()}</div>
          <div className="event-row-border" />
        </div>
      </div>
    );
  }
}
